import type { useMatchRoute } from "@tanstack/react-router";
import type { NavItemTarget, NavItemType } from "../types";

/** The matcher `useMatchRoute()` returns. Stable, so it can be passed down. */
export type MatchRoute = ReturnType<typeof useMatchRoute>;

function matchesTarget(matchRoute: MatchRoute, target: NavItemTarget): boolean {
  return !!matchRoute({ params: target.params, to: target.to });
}

/**
 * Selection was string equality against the concrete pathname. It is now a
 * route match, so a parameterised destination is compared as `to` + `params`
 * rather than as an interpolated string. External items never match: their
 * `href` is an absolute URL, which no pathname ever equalled either.
 */
export default function checkIfItemSelected(
  matchRoute: MatchRoute,
  item: NavItemType
): boolean {
  if (item.external) {
    return false;
  }
  return (
    matchesTarget(matchRoute, item) ||
    (item.alternativeTo?.some((target) => matchesTarget(matchRoute, target)) ??
      false)
  );
}
